import { createClient } from '@supabase/supabase-js';
import { chatRuntimeConfig } from './runtime';

export const supabase = createClient(
  chatRuntimeConfig.supabaseUrl,
  chatRuntimeConfig.supabasePublishableKey,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  },
);
